import "../CSS/Sponsors.css";

function Sponsors() {
  return (
    <div className="sponsoroverzicht">
      <p className="sponsorintro">Hoofdsponsor</p>
      <img src="/Sponsors/crelan.png" alt="Crelan" />
      <p className="sponsorintro">Verder dank aan deze sponsors:</p>
      <p className="sponsor">Peter Vanden Bussche</p>
      <p className="sponsor">Toon Logier</p>
      <p className="sponsor">ERH2</p>
      <img src="/Sponsors/assurrisk.png" alt="AssurRisk" />
      <img src="/Sponsors/bainterieur.png" alt="BA-Interieur" />
      <img src="/Sponsors/claerhout.png" alt="CCE" />
      <img src="/Sponsors/delaware.png" alt="Delaware" />
      <img src="/Sponsors/devagro.png" alt="Devagro" />
      <img src="/Sponsors/deweirt.jpg" alt="Deweirt" />
      <img src="/Sponsors/garagebettens.jpg" alt="Garage Bettens" />
      <img src="/Sponsors/keukenbouwer.png" alt="De Keukenbouwer" />
      <img src="/Sponsors/lootens.jpg" alt="Lootens Line" />
      <img src="/Sponsors/ouwehoeve.png" alt="d' Ouwe Hoeve" />
      <img src="/Sponsors/progicon.jpg" alt="Progicon" />
      <img src="/Sponsors/slagerijbc.jpg" alt="Slagerij B&C" />
      <img src="/Sponsors/steyro.png" alt="Steyro" />
      <img src="/Sponsors/techstreet.png" alt="Tech-Street" />
      <img src="/Sponsors/ufttools.jpg" alt="Ufttools-Uftlas" />
      <img src="/Sponsors/vandegeuchte.jpg" alt="Van de Geuchte" />
      <img src="/Sponsors/vandenavenne.png" alt="vanden avenne" />
      <img src="/Sponsors/verbeke.png" alt="Verbeke" />
      <img src="/Sponsors/weba.jpg" alt="Weba" />
      <img src="/Sponsors/welvaert.png" alt="Welvaert & Van Cauwenberghe" />
      <img src="/Sponsors/wmconsulting.jpg" alt="WM Consulting" />
    </div>
  );
}

export default Sponsors;
